import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=00c7be3e&"
import script from "./SearchHeader.vue?vue&type=script&lang=ts&"
export * from "./SearchHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports